<template>
	<div>
		
	<v-snackbar
		app
		v-model  = "inf.snack"
		:color   = "inf.color"
		:timeout = "inf.persistent ?  -1 : time"
		:top     = "inf.position  == 'top'"
		:bottom  = "inf.position  == 'bottom'"
		:right   = "inf.direction == 'right'"
		:left    = "inf.direction == 'left'"
		:key 	 = "'snack_notifications'"
	>
		<v-row 
			no-gutters
			class = "py-0"
		>
			<v-col 
				xl   = "11" 
				lg   = "11" 
				md 	 = "11" 
				xs 	 = "11" 
				cols = "11"
			>	
				<v-progress-circular
					indeterminate
					:size  = "25"
					v-show = "loading.active"
					:color = "loading.color"
				></v-progress-circular>
				<span 
					class = "body-1 mx-1"
				>					
					{{ inf.info }}
				</span>
			</v-col>
			<v-col 
				xl   = "1" 
				lg   = "1" 
				md   = "1" 
				xs   = "1" 
				cols = "1"
			>
				
				<v-btn
					icon
					dark
					small
					outlined
					color  = "error"
					class  = "elevation-5 error"
					@click = "inf.snack = false"
				>
					<v-icon 
						small 						
						color  = "white"
					>
						mdi-close
					</v-icon>
				</v-btn>
				
			</v-col>
		</v-row>
		

	</v-snackbar>
	<v-dialog 
		v-model = "inf.dialog" 
		:width  = "inf.width ? inf.width : 300" 
		v-if 	= "inf.type"
		:key 	 = "'modal_notifications'"

	>
		<v-card outlined>
			<v-card-title 
				class  = "justify-center pa-0 warning text-uppercase"
			>{{ $ml.get('confirm') }}</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<p 
					class = "mb-0 font-weight-medium body-1"
				>
					{{ inf.info }}
				</p>
				<!-- {{ list_options }} -->
					<!-- v-show  = "inf.is_options && list_options.length > 0" -->
				<template
					v-if 	= "list_options && list_options.length > 0"
				>
					<div v-for="(item_opt, idx_opt) in list_options" :key="item_opt.key || idx_opt">
						<v-text-field
							dense
							outlined
							hide-details
							v-if 			= "['text', 'number'].includes(item_opt.type)"
							:label 			= "item_opt.text"
							:placeholder 	= "item_opt.placeholder"
							v-model 		= "info_options[item_opt.key]"
							:value 			= "item_opt.default"
							class   		= "mt-1"
						></v-text-field>
						<v-textarea
							dense
							outlined
							hide-details
							v-if 			= "['textarea'].includes(item_opt.type)"
							:label 			= "item_opt.text"
							:placeholder 	= "item_opt.placeholder"
							v-model 		= "info_options[item_opt.key]"
							:value 			= "item_opt.default"
							class   		= "mt-1"

						></v-textarea>
						<v-checkbox
							dense
							outlined
							hide-details
							v-if 			= "['checkbox'].includes(item_opt.type)"
							:label 			= "item_opt.text"
							:placeholder 	= "item_opt.placeholder"
							v-model 		= "info_options[item_opt.key]"
							class   		= "mt-1"
						></v-checkbox>
					</div>
				</template>

			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					x-small 
					color 	= "primary"
					@click 	= "render_confirm(inf.ID, true)"
				>{{ $ml.get('confirm') }}</v-btn>
				<v-btn
					x-small 
					color 	= "error"
					@click 	= "render_confirm(inf.ID, false)"
				>{{ $ml.get('close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name 	: 'notifications',
		// notics_inf.vue
		props 	: ['info_to_notif'], // , 'color', 'status'
		data 	: ()=> ({
			snackbar: false,
			time: 7500, // 6000
			inf: {
				snack 	: false,
				color 	: '',
				info 	: '',
				dialog 	: false,
				width  	: null, // default  => 300 
				type 	: false, // true = > snack  : false => dialog
				is_options : false,
			},
			list_options 	: [],
			info_options 	: {},
			info_actions  	: null,
			loading 		: { 
				active : false,
				color  : "primary",
			},
		}), //data
		watch:{
			/*info: function(v){
				console.log(v, 'info notics');
				if(v.type){
					if (!v.dialog) {
						this.info.dialog=false;
						// this.$emit('close_snack_dialog', null);
					}

				}else{

					if (!v.info.snack) {
						// this.$emit('close_snack_dialog', null);
					}
				}
			}*/
			"inf.dialog" :function(val){
				// console.log("CHEK val dialog", val)
				if (!val) {
					if (this.inf && this.inf.ID && !this.inf.is_answered) {
						this.render_confirm(this.inf.ID, false);
					}
				}
			}
		}, // watch
		methods:{
			render_notifications(msg){
				if (msg) {

					let opt  = msg.type;
					let mssg = '';
					
					if (msg.message) {
						mssg = msg.message;
						if (mssg && typeof mssg  == 'object' ) {

							if (mssg.message == 'Network Error') {
								mssg = this.$ml.get('no_res_server');//mssg.message
							}else if (mssg.message.includes('status code 404')) {
								mssg = this.$ml.get('no_res_server') + ' : status code 404';//mssg.message

							}else if (mssg.msg){
								mssg = mssg.msg;
							}else if (mssg.response){
								if (mssg.response.data && mssg.response.data.msg) {
									mssg = mssg.response.data.msg;
								}else if (mssg.response.data && mssg.response.data.error) {
									mssg = mssg.response.data.error;
								}
							}
						}
					}
					let text 		 = '',
						colr 		 = '',
						type_modal 	 = false,
						is_snack 	 = false,
						is_dialog 	 = false,
						is_id 		 = null,
						is_direction = 'right',
						is_position  = 'top',
						is_persist   = false,
						is_options 	 = false,
						text_msg 	 = '';
					
					// FORZAR SNACK EN /list_parking
					if (this.$route && this.$route.path === '/list_parking') {
						is_snack = true;
						type_modal = false;
						is_dialog = false;
					}

					// console.log(opt, 'notifications')
					if (msg.direction) {
						is_direction = msg.direction;
					}
					if (msg.position) {
						is_position = msg.position;
					}
					if (msg.persistent) {
						is_persist = msg.persistent;
					}
					if (msg.loading) {
						this.loading.active = true;
					}else{
						this.loading.active = false;						
					}

					if (opt == 'saved') {
						text = this.$ml.get('saved') + ' ' + mssg;
						colr = 'success';				
						is_snack = true ;
					}
					
					if (opt == 'updated') {
						text = this.$ml.get('updated') + ' ' + mssg;
						colr = 'success';				
						is_snack = true ;
					}

					if (opt == 'deleted'){
						text = this.$ml.get('deleted') + ' ' + mssg;
						colr = 'success';
						is_snack = true ;
					}

					if (opt == 'error'){
						text = this.$ml.get('error') + ' ' + mssg;
						colr = 'error';
						is_snack = true ;
					}

					if (opt == 'warning'){
						text = this.$ml.get('warning') + ' ' + mssg;
						colr = 'warning';
						is_snack = true ;
					}

					if (opt == 'success') {
						text = ' ' + mssg;
						colr = 'success';				
						is_snack = true ;
					}	
					if (opt == 'connection'){
						text = mssg;
						colr = 'primary';
						is_snack = true ;
					}
					if (opt == 'primary') {
						text = ' ' + mssg;
						colr = 'primary';				
						is_snack = true ;
						this.loading.color = 'success';

					}else{
						this.loading.color = 'primary';
					}


					if (opt == 'confirm_delete') {
						text 		= this.$ml.get('ms_del') + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_id 		= msg.ID;
					}
					if (opt == 'confirm_upgrade') {
						text 		= this.$ml.get('confirm_upgrade') + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_id 		= msg.ID;
					}
					if (opt == 'confirm_reset') {
						text 		= this.$ml.get('confirm_reset') + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_id 		= msg.ID;
					}
					if (opt == 'logout') {
						text 		= this.$ml.get('confirm_logout') + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_id 		= msg.ID;	
					}
					if (opt == 'confirm_options') {
						text_msg 	= !msg.no_msg_default ? this.$ml.get('confirm_options') + ' : ' : '';
						text 		= text_msg + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_options  = true ;
						is_id 		= msg.ID;

					}
					if (opt == 'warnining_dialog') {
						text 		= this.$ml.get('warning') + ' ' + mssg;					
						is_dialog 	= true ;
						type_modal 	= true ; 
						is_id 		= msg.ID;	
					}
					if (msg.options && msg.options.length > 0) {
						this.list_options 	= [];
						this.info_options  	= {};
						this.$nextTick(()=>{
							this.list_options 	= [ ...msg.options ];
								// console.log("list_options : ", this.list_options);
							this.list_options.forEach((opt)=>{
								if (opt && opt.default) {
									this.info_options[opt.key] = opt.default;
								}else if (opt) {
									this.info_options[opt.key] = "";
								}
							})
						})
					}
					if (msg.action) {

						if (typeof msg == "object") {
							this.info_actions = {...msg.action};
						}else{
							this.info_actions = msg.action;

						}
					}else{
						this.info_actions = null;
					}

					this.inf = {
						snack 		: is_snack,
						color 		: colr,
						info 		: text,
						type 		: type_modal,
						dialog 		: is_dialog,
						snack 		: is_snack,
						ID 			: is_id,
						persistent 	: is_persist,
						direction  	: is_direction,  
						position    : is_position,
						is_answered : false,
						is_options,
						renderAction : msg.Action,
					};
				}else{
					console.warn(" Error notifications : not properties");
				}
			}, // render notifications

			render_confirm(key, opt){				
				let info_up = null;
				let actions = null;
				if (this.inf && this.inf.is_options && opt) {
					info_up 			= this.info_options ? { ...this.info_options  } : opt;
					this.inf.is_options = false;
					this.list_options 	= [];
					
					

				}else{
					info_up = opt;
					
				}
				if (this.info_actions) {
					actions 			= typeof this.info_actions == "object" ? { ...this.info_actions } : this.info_actions;
				}
				if (this.inf && this.inf.renderAction) {
					this.inf.renderAction(opt);
				}

				// console.log("send notifications ", info_up, actions)
				EventBus.$emit('notifications_modal' + key, info_up, actions)
				this.inf.is_answered = true;
				this.inf.dialog 	 = false;
				this.$nextTick(()=>{
					this.info_options  	= null;
					this.info_actions 	= null;
				})
				// EventBus.$off('notifications_modal' + key);
			}, // render_confirm
			
		}, // methods
		mounted(){
			EventBus.$on('notifications_modal', (action) =>{
				this.render_notifications(action);
			})
			 
		},
		beforeDestroy(){
			// Limpiar EventBus listeners
			EventBus.$off('notifications_modal');
		}
	};
</script>